/** @format */

// Proxy endpoint used to fetch AEM Pinned Content Spot (PCS) data.
// Swap this value (or its environment base) when the real AEM API is available.
export const PINNED_CONTENT_SPOT_ENDPOINT = '/api/aem/pinned-content-spot-list';

export const PINNED_CONTENT_RETRY_COUNT = 2;

export const PINNED_CONTENT_ERROR = 'PINNED_CONTENT_DATA_ERROR';
